module.exports = __webpack_public_path__ + "c82e4da775391c04bca91484b36c7c5c.svg";